import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';
import {Element} from 'react-scroll';

import log_blanco from '../../../assets/images/sitio/03_Patrocinadores_sitio_IES/Ies_Cooper.png';

import banner from '../../../assets/images/2022/stands/interiores/completos/stands_ind_cooper.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_v.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_v.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_v.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_v.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_v.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_v.png';
import btn_yt from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_yt_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_v.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_v.png';

const Cooper = (props) => {
  const { Panel } = Collapse;
  const { idioma,onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);

  return (
    <>
      <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
        
      </Row>
      <Row>
      <Col span={24} offset={0}>
        <a href="#video" onClick={()=>onMetrica('video',nombre)}>
          <img src={banner} style={{width:'100%'}} />
        </a>
        <br /><br />
        </Col>
        <Col span={20} offset={2}>
          {idioma === 'es' ?
          <p className="texto_patrocinadores">
            <span className='color_verde'><strong>SOBRE NOSOTROS</strong></span>
            <br />
          Somos una empresa de iluminación que ofrecemos soluciones innovadoras e integrales para aplicaciones de interior, exterior y control, específicamente diseñadas para maximizar el rendimiento, eficiencia energética y ahorro de energía. Dando una solución a cada mercado comercial, industrial, residenciales, entre otros.
        </p>
        :
        <p className="texto_patrocinadores">
          <span className='color_verde'><strong>ABOUT OUS</strong></span><br />
          We are a lighting company that offers innovative and comprehensive solutions for indoor, outdoor and control applications, specifically designed to maximize performance, energy efficiency and energy savings. Giving a solution to each commercial, industrial, residential market, among others.
        </p>}
        </Col>

        
        <Col span={16} offset={4}>
        <br />
        <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/uqjOscjtYmI?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          
          <br /><br />
        </Col>
        <Element name="#video"/>
        <Col xs={{span:20, offset:2}} md={{span:20, offset:2}}>
          <Row>
          <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20">
          {idioma === 'es' ? 
          <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525541867857&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Cooper%20Lighting%20Solutions%20de%20la%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" /></a>
        :
        <a onClick={()=>onMetrica('whatsapp',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525541867857&text=Hi,%20contact%20me%20from%20the%20Cooper%20Lighting%20Solutions%20stand%20at%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20">
          {idioma === 'es' ? 
          <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525554071540&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Cooper%20Lighting%20Solutions%20de%20la%20IES." onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" /></a>
        :
        <a onClick={()=>onMetrica('mail',nombre)} target="_blank" href="https://api.whatsapp.com/send?phone=525554071540&text=Hi,%20contact%20me%20from%20the%20Cooper%20Lighting%20Solutions%20stand%20at%20IES." onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20">
        {idioma === 'es' ?
        <a target="_blank" href="mailto:marketing.comunicacion@cooperlighting.com" onMouseEnter={()=>setHoverImagen(3)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 3 ? img_email_hover : img_email} style={{width:'100%'}} alt="video" /></a>
      :
      <a target="_blank" href="mailto:marketing.comunicacion@cooperlighting.com" onMouseEnter={()=>setHoverImagen(3)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 3 ? img_email_en_hover : img_email_en } style={{width:'100%'}} alt="video" /></a>}
        </Col>
          </Row>
        
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
        {idioma === 'es' ?
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        :
        <p className="titulo_patrocinador_texto">FREQUENT QUESTIONS</p>
        }
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ? 
            <Panel header="¿En dónde se fabrican los luminarios de Cooper Lighting Solutions?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Tenemos plantas en: Denver, CO, Vicksburg, MS, Peachtree City, GA, Americus, GA, Mexicali, B.C, Cd. Juárez, CH y Ciénega de Flores, N. L.
                  </p>
            </Panel>
            :
            <Panel header="Where are Cooper Lighting Solutions luminaires manufactured?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  We have plants in: Denver, CO, Vicksburg, MS, Peachtree City, GA, Americus, GA, Mexicali, B.C, Cd. Juárez, CH y Ciénega de Flores, N. L.
                  </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Qué servicios ofrece Cooper Lighting Solutions?" key="2" className="panel_patrocinador">
              <p className="texto_patrocinadores">
              Amplia gama de luminarios. Damos solución a mercados comercial, industrial, residencial, roadway, entre otros.
              <br /><br />
              Sustitución de luminarios. Remplazo básico uno a uno de los equipos de iluminación por equipos más eficientes.
              <br /><br />
              Diseño de iluminación. Estudio de iluminación por computadora considerando factores de su área, arreglo de luminarias y mejor selección de productos.
              <br /><br />
              Uso de sensores, tableros y sistemas de control. Ofrecemos equipos para ahorro de energía utilizando sensores de ocupación y luz natural. Maximizando el ahorro de energía.
              <br /><br />
              Enterprise. Puesta en marcha. Llave en mano.
                </p>
            </Panel>
            :
            <Panel header="What services does Cooper Lighting Solutions offer?" key="2" className="panel_patrocinador">
              <p className="texto_patrocinadores">
              Wide range of luminaires. We provide solutions to commercial, industrial, residential, roadway markets, among others.
              <br /><br />
              Replacement of lighting fixtures. Basic one-to-one replacement of lighting equipment with more efficient equipment.
              <br /><br />
              Illumination design. Computer lighting study considering factors of your area, arrangement of luminaires and best selection of products.
              <br /><br />
              Use of sensors, boards and control systems. We offer energy saving equipment using occupancy and natural light sensors. Maximizing savings energy.
              <br /><br />
              Enterprise. Start up. Key on hand.
                </p>
            </Panel>}
            {idioma === 'es' ? 
            <Panel header="¿Qué tecnologías manejan en sus luminarios?" key="3" className="panel_patrocinador">
            <ul className="texto_patrocinadores">
            <li>COB (Chip on board)</li>
            <li>Linear LED</li>
            <li>WaveStream (Patente CLS)</li>
            <li>AccuLED – (Light Bar, Square Bar)</li>
              </ul>
            </Panel>
            :
            <Panel header="What technologies do you use in your luminaires?" key="3" className="panel_patrocinador">
            <ul className="texto_patrocinadores">
            <li>COB (Chip on board)</li>
            <li>Linear LED</li>
            <li>WaveStream (Patente CLS)</li>
            <li>AccuLED – (Light Bar, Square Bar)</li>
              </ul>
            </Panel>}
            {idioma === 'es' ? 
            <Panel header="¿Cuál es su página Web?" key="4" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            <a target="_blank" className="texto_patrocinadores_link" href="https://www.cooperlighting.com/º">https://www.cooperlighting.com/</a>
              </p>
            </Panel>
            :
            <Panel header="Which is your website?" key="4" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            <a target="_blank" className="texto_patrocinadores_link" href="https://www.cooperlighting.com/º">https://www.cooperlighting.com/</a>
              </p>
            </Panel>}
            {idioma === 'es' ? 
            <Panel header="Tienen cursos en línea?" key="5" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Si, contamos con una variedad de cursos, en español e inglés. Algunos de ellos son en vivo bajo la modalidad on line y otros están precargados en la plataforma. Los pueden revisar en los siguientes links:<br />
            
            <br />
            <a target="_blank" className="texto_patrocinadores_link" href="https://go.bluevolt.com/sourceonline/s/">https://go.bluevolt.com/sourceonline/s/</a><br />
            Cualquier duda sobre estos cursos pueden ponerse en contacto al correo: <a target="_blank" className="texto_patrocinadores_link" href="mailto:marketing.comunicacion@cooperlighting.com">marketing.comunicacion@cooperlighting.com</a>

              </p>
            </Panel>
            :
            <Panel header="Do you have online courses?" key="5" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Yes, we have a variety of courses, in Spanish and English. Some of them are live under the online mode and others are preloaded on the platform. You can review them in the following links:<br />
            <a target="_blank" className="texto_patrocinadores_link" href="https://drive.google.com/file/d/1PQfg7J1TZ2doMnEC1F21YxtfwG5nGDZK/view">https://drive.google.com/file/d/1PQfg7J1TZ2doMnEC1F21YxtfwG5nGDZK/view</a>
            <br />
            <a target="_blank" className="texto_patrocinadores_link" href="https://go.bluevolt.com/sourceonline/s/">https://go.bluevolt.com/sourceonline/s/</a><br />
            Any questions about these courses can be contacted by email: <a target="_blank" className="texto_patrocinadores_link" href="mailto:marketing.comunicacion@cooperlighting.com">marketing.comunicacion@cooperlighting.com</a>
              </p>
            </Panel>}
            {idioma === 'es' ? 
            <Panel header="¿Cooper Lighting Solutions cuenta con certificados NOM en sus productos?" key="6" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Si, los productos que comercializamos en México cuentan certificación NOM. De acuerdo con la normatividad vigente en territorio nacional la clasificación y aplicación de la norma de seguridad y eficiencia para los productos de iluminación, se consideran las siguientes características:
              </p>
              <ul className="texto_patrocinadores">
              <li>Tipo de producto</li>
              <li>Características técnicas y físicas del producto</li>
              <li>Uso destinado</li>
              </ul>
              <p className="texto_patrocinadores">
              Para los productos de iluminación y artefactos eléctricos se tienen 3 Normas Oficiales Mexicanas
              </p>
              <ul className="texto_patrocinadores">
              <li>NOM-003-SCFI-2014 - Productos eléctricos-Especificaciones</li>
              <li>NOM-031-ENER-2012, Eficiencia energética para luminarios con diodos emisores de luz (leds) destinados a vialidades y áreas exteriores públicas</li>
              <li>NOM-064-SCFI-2000, Productos eléctricos-Luminarios para uso en interiores y exteriores</li>
              </ul>
            </Panel>
            :
            <Panel header="Does Cooper Lighting Solutions have NOM certificates on its products?" key="6" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Yes, the products we sell in Mexico have NOM certification. In accordance with the regulations in force in the national territory, the classification and application of the safety and efficiency standard for lighting products, the following characteristics are considered:
              </p>
              <ul className="texto_patrocinadores">
                <li>Kind of product</li>
                <li>Technical and physical characteristics of the product</li>
                <li>Intended use</li>
                <li>For lighting products and electrical appliances there are 3 Official Mexican Standards</li>
                <li>NOM-003-SCFI-2014 - Electrical Products-Specifications</li>
                <li>NOM-031-ENER-2012, Energy efficiency for luminaires with light-emitting diodes (LEDs) for roads and public outdoor areas</li>
                <li>NOM-064-SCFI-2000, Electrical products-Luminaires for indoor and outdoor use</li>
              </ul>
            </Panel>}
            {idioma === 'es' ? 
            <Panel header="¿Cooper Lighting Solutions cuenta con un centro de capacitación?" key="7" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Si, nuestro centro de capacitación (The Source) se encuentra ubicado en nuestras oficinas corporativas en Peachtree City, GA.; estas instalaciones cuentan con más de 3,000 m2 de exhibición física en constante actualización de tecnologías.
            <br /><br />
            Desde su creación más de 100,000 personas se han beneficiado con el más alto nivel de educación de iluminación y control, incluyendo estudiantes, ingenieros, arquitectos, contratistas, eléctricos, distribuidores, clientes finales y especificadores.
              </p>
            </Panel>
            :
            <Panel header="Does Cooper Lighting Solutions have a training center?" key="7" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Yes, our training center (The Source) is located at our corporate offices in Peachtree City, GA .; These facilities have more than 3,000 m2 of physical exhibition in constant updating of technologies.
            <br /><br />
            Since its inception, more than 100,000 people have benefited from the highest level of lighting and control education, including students, engineers, architects, contractors, electricians, distributors, end customers, and specifiers.
              </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Con que clientes ha trabajado Cooper Lighting Solutions (Casos de éxito)?" key="8" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Hemos trabajado con diferentes clientes de diferentes segmentos como: OXXO, Coppel, Zapatos Andrea, Prologis, Toks, Sigma, Alestra, ITESM, Hospital San José, Hospital Naval, Universidad de Costa Rica, Denso, Home Depot, Ternium, CEMEX. Facebook, MAC, Plazas Sendero, FINSA, Vitro, Frisco, Grupo Modelo, OMA, Fashion Drive, Benavides, General Motors entre muchos otros.
              </p>
            </Panel>
            :
            <Panel header="Which clients has Cooper Lighting Solutions worked with (Success stories)?" key="8" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            We have worked with different clients from different segments such as: OXXO, Coppel, Zapatos Andrea, Prologis, Toks, Sigma, Alestra, ITESM, Hospital San José, Hospital Naval, Universidad de Costa Rica, Denso, Home Depot, Ternium, CEMEX. Facebook, MAC, Plazas Sendero, FINSA, Vitro, Frisco, Grupo Modelo, OMA, Fashion Drive, Benavides, General Motors among many others.
              </p>
            </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Cuántos años de garantía tienen sus productos?" key="9" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            Contamos con 5 años de garantía.
            <br />
            También contamos con algunas garantías extendidas. (Revisar con su agente de ventas las condiciones de estas).
              </p>
            </Panel>
            :
            <Panel header="How many years of warranty do your products have?" key="9" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            We have a 5-year warranty.
            <br />
            We also have some extended warranties. (Review the conditions of these with your sales agent).
              </p>
            </Panel>}
          </Collapse>
        </Col>
        <Col span={20} offset={2}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}>
        
        <Row justify='center'>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)} href="https://www.facebook.com/Cooperlightingmexico" target="_blank" onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_fb_hover : btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('twitter',nombre)} href="https://twitter.com/lighting_cooper" target="_blank" onMouseEnter={()=>setHoverRedes(2)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 2 ? btn_tw_hover : btn_tw} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)} href="" target="_blank"><img src={btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)} href="https://www.instagram.com/cooperlightingsolutionsmx/" target="_blank" onMouseEnter={()=>setHoverRedes(3)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 3 ? btn_in_hover : btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('youtube',nombre)} href="https://www.youtube.com/c/CooperLightingSolutions" target="_blank" onMouseEnter={()=>setHoverRedes(4)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 4 ? btn_yt_hover : btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Cooper;